import store from './store';

function get(pc,mobile){
  return store.state.width>960 ? pc : mobile;
}

export default {
  get
};



// WEBPACK FOOTER //
// ./src/pcmobile.js